export class OOTSRequestStatus {
    uuid: string;
    requirements: RequirementStatus[];
    public constructor(uuid: string, requirements: RequirementStatus[]) {
        this.uuid = uuid;
        this.requirements = requirements;
    }
}

export class RequirementStatus {
    requirementId: string;
    status: string;
    evidences: EvidenceStatus[];
    public constructor(requirementId: string, status: string, evidencesStatus: EvidenceStatus[]) {
        this.requirementId = requirementId;
        this.status = status;
        this.evidences = evidencesStatus
    }
}

export class EvidenceStatus {
    evidenceUUID: string;
    countryCode: string;
    evidenceIdentifier: string;
    status: string;
    evidenceTypeClassification: string;
    evidenceTitle: string;
    accessServiceIdentifier: string;
    publisherIdentifier: string;
    publisherName: string;
}